import clienteAxios from '../api/axios';

export const postEnrolled = async (data) => {
	try {
		const res = await clienteAxios.post('/api/enrolled', data, {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Access-Control-Allow-Origin': '*',
			},
		});

		return res;
	} catch (error) {
		console.log(error);
		return error;
	}
};
